import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, History } from "lucide-react";
import { api } from "../lib/api";
import { formatINR, formatDate } from "../lib/format";

// Toggle-able history of past (closed) monthly milestone cycles.
export default function MilestoneHistoryPanel() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && !data) {
      setLoading(true);
      api.get("/milestones/history")
        .then(({ data }) => setData(data))
        .catch((e) => console.error("Failed to load milestone history:", e))
        .finally(() => setLoading(false));
    }
  }, [open, data]);

  const cycles = data?.cycles || [];

  return (
    <div className="card-base overflow-hidden">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-5 py-4 text-left"
      >
        <div className="flex items-center gap-2">
          <History className="h-4 w-4 text-[#F97316]" />
          <span className="font-semibold text-gray-900">Milestone History</span>
        </div>
        {open ? <ChevronUp className="h-4 w-4 text-gray-400" /> : <ChevronDown className="h-4 w-4 text-gray-400" />}
      </button>

      {open && (
        <div className="px-5 pb-5 border-t border-gray-100 pt-4">
          {loading && <div className="text-sm text-gray-500">Loading…</div>}

          {!loading && cycles.length === 0 && (
            <div className="text-sm text-gray-500">No past cycles yet — your first one is still in progress.</div>
          )}

          {!loading && cycles.length > 0 && (
            <table className="w-full text-sm">
              <thead className="text-[11px] text-gray-500 uppercase bg-gray-50">
                <tr>
                  <th className="text-left px-3 py-2">Cycle</th>
                  <th className="text-right px-3 py-2">Agreements</th>
                  <th className="text-right px-3 py-2">Tiers hit</th>
                  <th className="text-right px-3 py-2">Unlocked</th>
                </tr>
              </thead>
              <tbody>
                {cycles.map((c) => (
                  <tr key={c.id} className="border-t border-gray-100">
                    <td className="px-3 py-2 text-gray-600">{formatDate(c.cycle_start)} – {formatDate(c.cycle_end)}</td>
                    <td className="px-3 py-2 text-right">{c.agreements_count}</td>
                    <td className="px-3 py-2 text-right">{(c.milestones_achieved || []).length}</td>
                    <td className="px-3 py-2 text-right font-medium text-emerald-600">{formatINR(c.total_earned_this_cycle_paise)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
